import { Transitions } from '../../system';

const transitions: Transitions = {
  buttonHover: 'background-color 0.15s ease',
  focus: 'box-shadow 0.15s ease',
  linkHover: 'color 0.15s ease',
};

export default transitions;
